import { getMonthName } from "../../../extensions/helper";

const CalendarMonth = ({year, month, width, height, top, left, currentMonth}) => {

  const style = { width,  height, top, left }
  const text = year ? `${getMonthName(month)} ${year}` : '';
  return<div style={style} className={`calendar-month ${currentMonth ? " calendar-month-current" : ""}`}><div className="calendar-month-text">{text}</div></div>
}

export default CalendarMonth;